import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import {
    getHideTradesPerfKpis,
    setHideTradesPerfKpis,
} from "../utils/tradesPerfKpisCookie";

export const usePerformanceVisibility = (
    userId?: string,
    enabled = true
) => {
    const location = useLocation();
    const [hidePerformance, setHidePerformanceState] = useState(() =>
        Boolean(enabled && userId && getHideTradesPerfKpis(userId))
    );

    useEffect(() => {
        setHidePerformanceState(
            Boolean(enabled && userId && getHideTradesPerfKpis(userId))
        );
    }, [enabled, userId, location.pathname, location.search]);

    const setHidePerformance = (hidden: boolean) => {
        if (!enabled || !userId) return;
        setHideTradesPerfKpis(userId, hidden);
        setHidePerformanceState(hidden);
    };

    const togglePerformance = () =>
        setHidePerformance(!hidePerformance);

    return {
        hidePerformance: enabled && hidePerformance,
        setHidePerformance,
        togglePerformance,
    };
};
